<template>
  <section id="contact" class="pt-10">
    <v-row align="center" justify="center">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="9" xl="9">
            <div class="text-center mt-4">
              <h1 class="section-title font-weight-light">Наши контакты</h1>
              <h4 class="section-subtitle font-weight-light">Онлайн-сервис Налог-сервис – профессиональная помощь по
                заполнению декларации 3-НДФЛ и оформлению налогового вычета.</h4>
            </div>
          </v-col>
          <v-col cols="12" md="9" xl="9" class="mt-6 mb-6 contact-card" style="padding-left: 0; padding-right: 0;">
            <v-row>
              <v-col md="6" sm="6" xs="12">
                <p>
                  <span class="title">ООО "ИНФОРМКАРТ"</span> <span class="value"></span>
                </p>
                <p>
                  <span class="title">ИНН:</span> <span class="value">7420010847</span>
                </p>
                <p>
                  <span class="title">ОГРН:</span> <span class="value">1067420016168</span>
                </p>
                <p>
                  <span class="title">СЧЁТ:</span> <span class="value">40702810007710002545</span>
                </p>
                <p>
                  <span class="title">БАНК:</span> <span class="value">В ПАО «Челиндбанк»</span>
                </p>
                <p>
                  <span class="title">БИК:</span> <span class="value">047501711</span>
                </p>
              </v-col>
              <v-col md="6" sm="6" xs="12">
                <p>
                  <span class="title"><v-icon>mdi-phone</v-icon>Колл-центр 24/7:</span><br><span class="value"><a href="tel:+79208379193">+7 (920) 837-91-93</a></span>
                </p>
                <p>
                  <span class="title"><v-icon>mdi-message-reply-text-outline</v-icon> Мессенджеры:</span>
                <div>
                  <a href="https://wa.me/79127916470" class="d-inline-block pa-2">
                    <v-img src="@/assets/image/whatsapp_logo.png" width="50px" title="Написать в WhatsApp"/>
                  </a>
                  <a href="https://t.me/+79127916470" class="d-inline-block pa-2">
                    <v-img src="@/assets/image/telegram_logo.png" width="50px" title="Написать в Telegram"/>
                  </a>
                  <a href="viber://chat?number=%2B79127916470" class="d-inline-block pa-2">
                    <v-img src="@/assets/image/viber_logo.png" width="50px" title="Написать в Viber"/>
                  </a>
                </div>
                </p>
                <p><span class="title"><v-icon>mdi-email-outline</v-icon>По всем вопросам:</span><br><span
                    class="value"><a href="mailto:NALOG-SERVICE@INTERNET.RU">NALOG-SERVICE@INTERNET.RU</a></span></p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>


<script>

export default {
  data: () => ({}),
};
</script>

<style lang="scss">
.contact-card {
  .title {
    color: #005096;
    font-size: 22px !important;
  }

  .value {
    padding-left: 10px;
    font-weight: 600;
  }

  .v-icon {
    padding-right: 5px;
    color: #005096;
  }
}

</style>